import { render, staticRenderFns } from "./ParentsIncomeRow.vue?vue&type=template&id=173ff954&"
import script from "./ParentsIncomeRow.vue?vue&type=script&lang=js&"
export * from "./ParentsIncomeRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports